import React from "react";
import { Field } from "formik";
import Input from "../../../DataEntry/Input";
import Search from "../../../DataEntry/Search";

export class Returning extends React.Component<any, any> {
  renderInput = (name: string, label: string) => {
    const { viewOnly } = this.props;
    return (
      <td>
        <small className="text-muted">{label}</small>
        <br />
        <Field
          component={Input}
          name={name}
          className="form-control"
          disabled={viewOnly}
        />
      </td>
    );
  };

  render() {
    const { client, crm_return, info, store, viewOnly } = this.props;

    return (
      <>
        <div className="row" style={{ marginTop: "20px" }}>
          <div className="col-xs-12">
            <table className="table sn-table table-striped table-hover">
              <thead className="gray-header">
                <tr className="center-content">
                  <th>
                    Return <br /> Date/Time
                  </th>
                  <th>Return #</th>
                  {crm_return.id && [
                    <th key="schedule-number">Related SO #</th>,
                    <th key="customers" className="text-left">
                      Customer(s)
                    </th>,
                    <th key="reader">Reader</th>,
                  ]}
                  <th>Receiving Zone</th>
                  <th>Ship From</th>
                </tr>
              </thead>
              <tbody>
                <tr className="center-content">
                  <td>
                    {info.returnDate}
                    <br />
                    {info.returnTime}
                  </td>
                  <td>{info.returnNumber}</td>
                  {crm_return.id && [
                    <td key="schedule-number">
                      {info.schedules.map((schedule: any, index: number) => (
                        <span key={schedule.id}>
                          {!!index && ", "}
                          <a
                            href={`/${client}/${store}/crm/schedules/${schedule.id}/edit`}
                            target="_blank"
                          >
                            {schedule.schedule_number}
                          </a>
                        </span>
                      ))}
                    </td>,
                    <td key="customers" className="text-left">
                      {info.customers.map((customer: any, index: number) => (
                        <span key={customer.id}>
                          {!!index && ", "}
                          <a
                            href={`/${client}/${store}/crm/customers/${customer.id}/edit`}
                            target="_blank"
                          >
                            {customer.company}
                          </a>
                        </span>
                      ))}
                    </td>,
                    <td key="reader">{crm_return.reader_name}</td>,
                  ]}
                  <td className="text-left">
                    <Field
                      component={Search}
                      name="receiving_zone_id"
                      options={info.subzones.map((i: any) => ({
                        value: i.id,
                        label: i.name,
                      }))}
                      isDisabled={viewOnly}
                      isSearchable
                      style={{ width: "100%" }}
                    />
                  </td>
                  <td>
                    <Field
                      component={Input}
                      name="shipped_from"
                      className="form-control"
                      disabled={viewOnly}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="row" style={{ marginTop: "20px" }}>
          <div className="table-responsive col-xs-12">
            <table className="table sn-table table-striped table-hover">
              <thead className="green-header">
                <tr className="center-content">
                  <th colSpan={6}>Return Details</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  className="center-content"
                  style={{
                    height: "70px",
                    verticalAlign: "middle",
                    paddingTop: "0",
                  }}
                >
                  {this.renderInput("carrier", "Carrier")}
                  {this.renderInput("vehicle_plate_number", "Vehicle Plate #")}
                  {this.renderInput("driver_name", "Driver Name")}
                  {this.renderInput("driver_phone", "Driver Phone")}
                  {this.renderInput(
                    "vehicle_trailer_number",
                    "Vehicle Trailer #",
                  )}
                  {this.renderInput("carrier_tracking_number", "Tracking #")}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }
}
